import { useEffect, useState } from 'react';

export interface LovemoDownloadConfig {
  android: string;
  ios: string;
  harmonyos: string;
  windows: string;
}

export interface LovemoContactConfig {
  email: string;
  emailLabel: string;
}

export interface LovemoConfig {
  downloads: LovemoDownloadConfig;
  contact: LovemoContactConfig;
}

export const LOVEMO_DEFAULT_CONFIG: LovemoConfig = {
  downloads: {
    android: 'https://www.lovemoai.net',
    ios: 'https://www.lovemoai.net',
    harmonyos: 'https://www.lovemoai.net',
    windows: 'https://www.lovemoai.net',
  },
  contact: {
    email: 'txby666666@163.com',
    emailLabel: '联系邮箱',
  },
};

const LOVEMO_LOCAL_CONFIG_URL = `${import.meta.env.BASE_URL}lovemo-config.json`;
const LOVEMO_REMOTE_CONFIG_URL = 'https://www.lovemoai.net/lovemo-config.json';

interface LovemoPartialConfig {
  downloads?: Partial<LovemoDownloadConfig>;
  contact?: Partial<LovemoContactConfig>;
}

async function lovemoLoadJson(url: string): Promise<LovemoPartialConfig | null> {
  try {
    const separator = url.includes('?') ? '&' : '?';
    const res = await fetch(`${url}${separator}t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = (await res.json()) as LovemoPartialConfig;
    if (!data || typeof data !== 'object') return null;
    return data;
  } catch {
    return null;
  }
}

function lovemoMergeConfig(data: LovemoPartialConfig | null): LovemoConfig {
  if (!data) return LOVEMO_DEFAULT_CONFIG;
  return {
    downloads: { ...LOVEMO_DEFAULT_CONFIG.downloads, ...(data.downloads || {}) },
    contact: { ...LOVEMO_DEFAULT_CONFIG.contact, ...(data.contact || {}) },
  };
}

/**
 * 读取外置 JSON 配置（下载链接 / 联系邮箱）。
 * 优先读取站点根目录下的 lovemo-config.json，读取失败再尝试官网地址，
 * 最终回退到内置默认值。修改 JSON 即可更新，无需重新构建源码。
 */
export function useLovemoConfig() {
  const [config, setConfig] = useState<LovemoConfig>(LOVEMO_DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      let data = await lovemoLoadJson(LOVEMO_LOCAL_CONFIG_URL);
      if (!data) {
        data = await lovemoLoadJson(LOVEMO_REMOTE_CONFIG_URL);
      }
      if (!active) return;
      setConfig(lovemoMergeConfig(data));
      setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, []);

  return { config, loading };
}